import { Validators } from '@angular/forms';
import { IGenCatForm, NgGenCatInputTextComponent } from '@ctti-dev/ng-gencat';

export const FORGOTTEN_PASSWORD_FORM_CONFIG: IGenCatForm = {
  username: {
    component: NgGenCatInputTextComponent,
    customClass: 'col-12',
    label: 'forgotPassword.form.user',
    size: 'small',
    optionalLabel: false,
    typeInput: 'text',
    placeholder: "Escriu el teu nom d'usuari",
    validators: [Validators.required],
  },
};
